"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hyperLink = _interopRequireDefault(require("./hyper-link"));

var _default = _hyperLink.default;
exports.default = _default;